import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { UiAlpha } from '../../../../styles/ui-alpha';

export const useStyles = makeStyles<Theme>()((theme) => ({
  container: {
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    minHeight: '100vh',
    '@supports (height: 100dvh)': {
      minHeight: '100dvh',
    },
    zIndex: theme.zIndex.modal,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: theme.palette.text.primary,
    maxWidth: 420,
    width: '100%',
    padding: theme.spacing(3),
  },
  mainContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto',
    textAlign: 'center',
    width: '100%',
  },
  iconSquare: {
    ...theme.mixins.appIconTintSquare,
    marginBottom: theme.spacing(3),
  },
  errorImage: {
    display: 'block',
  },
  pageTitle: {
    color: theme.palette.text.primary,
  },
  pageDescription: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    color: theme.palette.text.secondary,
    maxWidth: 360,
  },
  block: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: 400,
    gap: theme.spacing(2),
  },
  versionCompareRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
  },
  versionBadgeError: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '100%',
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 999,
    backgroundColor: alpha(theme.palette.error.main, UiAlpha.Tint),
    color: theme.palette.error.main,
  },
  versionBadgePrimary: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '100%',
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 999,
    backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Tint),
    color: theme.palette.primary.main,
  },
  versionStrikethrough: {
    textDecoration: 'line-through',
  },
  versionArrow: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(22),
    flexShrink: 0,
  },
  versionValue: {
    wordBreak: 'break-word',
    textAlign: 'center',
  },
  updateButton: {
    width: '100%',
  },
  buttonIcon: {
    width: 20,
    height: 20,
    display: 'block',
  },
  warningAlert: {
    width: '100%',
    textAlign: 'left',
    '& .MuiAlert-message': {
      textAlign: 'left',
    },
  },
}));
